var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"referrerpolicy":"no-referrer-when-downgrade","src":"https://matomo.bonkers.ie/matomo.php?idsite=1&rec=1","alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }